import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function liveStreamReducer(state = initialState.liveStream, action) {
  switch (action.type) {
    case types.GET_LIST_LIVE_STREAM_SUCCESS: {
      return state.set('memberLiveStreams', action.data);
    }

    case types.SET_LIST_CURRENT_LIVE_STREAM_SUCCESS: {
      return state.set('listCurrentLiveStream', action.data);
    }

    case types.SET_LOCAL_STREAM_SUCCESS: {
      return state.set('hiddenStatusBar', true);
    }

    case types.HIDE_STATUS_BAR: {
      return state.set('hiddenStatusBar', action.data);
    }

    case types.RESET_SELECTED_STREAM: {
      // console.log('RESET_SELECTED_STREAM');
      const streamId = action.data;
      const { loginUserStream } = state;
      // state = state.set('hiddenStatusBar', false);
      if (streamId && loginUserStream.streamId === streamId) {
        if (loginUserStream.streamId === streamId) {
          return state.set(['loginUserStream'], initialState.liveStream.loginUserStream);
        } else {
          state = state.setIn(['viewerByStreamId', streamId], [])
        }
      }

      return state.set(['selectedStream'], initialState.liveStream.selectedStream);
    }

    case types.RESET_LIVE_STREAM_IN_ROOM: {
      // console.log('RESET_LIVE_STREAM_IN_ROOM');
      // state = state.set('hiddenStatusBar', false);
      return state.set(['listLiveStreamsInRoom'], initialState.liveStream.listLiveStreamsInRoom);
    }

    case types.WATCH_LIVE_STREAM_SUCCESS: {
      // console.log('WATCH_LIVE_STREAM_SUCCESS', action.data);
      // state = state.set('hiddenStatusBar', true);
      return state.setIn(['selectedStream', 'streamId'], action.data.streamId);
      // return state.set(['selectedStream', 'streamName'], action.data.p_xmppId);
    }

    case types.SELECT_STREAM_IN_ROOM_SUCCESS: {
      // console.log('SELECT_STREAM_IN_ROOM_SUCCESS', action.data);
      // state = state.set('hiddenStatusBar', true);
      return state.setIn(['selectedStream', 'streamId'], action.data.id);
      // return state.set(['selectedStream', 'streamName'], action.data.owner_xmppId);
    }

    case types.SELECT_STREAM_PUBLISHER_IN_ROOM_SUCCESS: {
      // console.log('SELECT_STREAM_IN_ROOM_SUCCESS', action.data);
      // state = state.set('hiddenStatusBar', true);
      return state.setIn(['loginUserStream', 'streamId'], action.data.id);
    }

    case types.GET_STREAM_DETAIL_SUCCESS: {
      const listViewer = action.data.listViewer.filter((value, index, self) => {
        return self.lastIndexOf(value) === index;
      });
      const { streamId } = action.data;
      const { loginUserStream } = state;
      // console.log('GET_STREAM_DETAIL_SUCCESS', listViewer);
      if (streamId && loginUserStream.streamId === streamId) {
        return state.setIn(['loginUserStream', 'listViewer'], listViewer);
      }
      // return state;//.setIn(['selectedStream', 'listViewer'], action.data);
      return state
        .setIn(['selectedStream', 'listViewer'], listViewer)
        .setIn(['viewerByStreamId', streamId], listViewer);
    }

    case types.ADD_VIEWER_VIEW_LIVE_STREAM: {
      const { loginUserStream } = state;
      const {streamId, userId} = action;
      if (streamId && loginUserStream.streamId === streamId) {
        return state.setIn(['loginUserStream', 'listViewer'], Array.from(new Set([...state.loginUserStream.listViewer, userId])));
      }

      const listViewerNext = Array.from(new Set([...(state.viewerByStreamId[streamId] || []), userId]));
      state = state.setIn(['viewerByStreamId', streamId], listViewerNext);
      return state;
    }

    case types.REMOVE_VIEWER_VIEW_LIVE_STREAM: {
      const {streamId, userId} = action;
      const { loginUserStream } = state;
      if (streamId && loginUserStream.streamId === streamId) {
        return state.setIn(['loginUserStream', 'listViewer'], state.loginUserStream.listViewer.filter(uId => uId !== userId));
      }

      const listViewerNext = (state.viewerByStreamId[streamId] || []).filter(uId => uId !== userId);
      return state.setIn(['viewerByStreamId', streamId], listViewerNext)
    }

    case types.GET_LIST_LIVE_STREAM_IN_ROOM_SUCCESS: {
      // console.log("getListLiveStreamsInRoom 4", action.data);
      return state.set('listLiveStreamsInRoom', action.data).set('toggleCheckLiveStream', Math.random().toString(36).substring(5)); // Using this field to let App know when should check list subscribers again
    }

    case types.ADD_NEW_LIVE_STREAM_SUCCESS: {
      const addListLiveStreams = state.listLiveStreamsInRoom.asMutable() || [];
      addListLiveStreams.push(action.data);
      // console.log('ADD_NEW_LIVE_STREAM_SUCCESS', action.data);
      return state.set(['listLiveStreamsInRoom'], addListLiveStreams);
    }

    case types.REMOVE_LIVE_STREAM_SUCCESS: {
      const listLiveStreams = state.listLiveStreamsInRoom.asMutable() || [];

      const livestream = listLiveStreams.find(stream => stream.owner_userId === action.data.userId);
      if (livestream) {
        const index = listLiveStreams.indexOf(livestream);
        if (index > -1) {
          listLiveStreams.splice(index, 1);
        }
      }
      // addListLiveStreams.push(action.data);
      console.log('REMOVE_LIVE_STREAM_SUCCESS', listLiveStreams);
      return state.set('listLiveStreamsInRoom', listLiveStreams);
    }

    case types.ADD_NEW_WATCHER_SUCCESS: {
      const newListViewer = state.selectedStream.listViewer.asMutable() || [];
      newListViewer.push(action.data);
      // console.log('ADD_NEW_WATCHER_SUCCESS', newListViewer);
      return state.setIn(['selectedStream', 'listViewer'], newListViewer);
    }

    case types.REMOVE_WATCHER_SUCCESS: {
      const newListViewer = state.selectedStream.listViewer.asMutable() || [];
      const xmppId = newListViewer.find(e => e === action.data);
      if (xmppId) {
        const index = newListViewer.indexOf(xmppId);
        if (index > -1) {
          newListViewer.splice(index, 1);
        }
      }
      // console.log('REMOVE_WATCHER_SUCCESS', newListViewer);
      return state.setIn(['selectedStream', 'listViewer'], newListViewer);
    }
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.liveStream;
      return state;
    }
    default:
      return state;
  }
}
